// material-ui
import { useTheme } from "@mui/material/styles";
import { Avatar, Box, Chip, Typography } from "@mui/material";

// project imports
import LogoSection from "../LogoSection";
// import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import LocalizationSection from './LocalizationSection';
import { useDispatch, useSelector } from "react-redux";

import { openDrawer } from "store/slices/menu";

// assets
import { IconMenu2 } from "@tabler/icons";
import ProfileContainer from "containers/profile/Profile.container";
import { red } from "@mui/material/colors";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import { useState } from "react";
// import GitInfo from 'react-git-info/macro';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  // const gitInfo = GitInfo();

  const theme = useTheme();
  const { i18n } = useTranslation()
  const dispatch = useDispatch();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [nowDate, setNowDate] = useState(`${DateTime.now().toLocaleString(
    { day: 'numeric', month: "long", year: "numeric", }, {
    locale: i18n?.language ? i18n.language : "it",
  })},
  ${DateTime.now().toLocaleString(
    { hour: '2-digit', minute: '2-digit', }, {
    locale: i18n?.language ? i18n.language : "it",
  })}`)

  // eslint-disable-next-line
  const timeDateInterval = setInterval(() => {

    setNowDate(`${DateTime.now().toLocaleString(
      { day: 'numeric', month: "long", year: "numeric", }, {
      locale: i18n?.language ? i18n.language : "it",
    })},
    ${DateTime.now().toLocaleString(
      { hour: '2-digit', minute: '2-digit', }, {
      locale: i18n?.language ? i18n.language : "it",
    })}`)
  }, 1000);

  return (
    <>
      {/* logo & toggler button */}
      <Box
        sx={{
          width: 221,
          display: "flex",
          [theme.breakpoints.down("md")]: {
            width: 160,
          },
        }}
      >
        <Box
          component="span"
          sx={{ display: { xs: "block", md: "block" }, flexGrow: 1 }}
        >
          <LogoSection />
        </Box>
      </Box>
      <Box ml={1}>
        {process.env.REACT_APP_ENVIRONMENT &&
          process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "production" &&
          process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "produzione" &&
          process.env.REACT_APP_ENVIRONMENT?.toLowerCase() !== "prod" && (
            <Chip
              label={process.env.REACT_APP_ENVIRONMENT}
              sx={{ backgroundColor: red[100], color: red[800] }}
              size="small"
            />
          )}
      </Box>

      {/* header search */}
      {/* <SearchSection /> */}
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <Typography textTransform='capitalize' variant='caption'>
          {nowDate}
        </Typography>
      </Box>
      {/* live customization & localization */}
      <Box sx={{ display: { xs: 'none', sm: 'block', padding: 10 } }}>
        <LocalizationSection />
      </Box>

      {/* notification & profile */}
      {/* <NotificationSection /> */}
      {/* mobile header */}
      <Box sx={{ display: { xs: 'flex', sm: 'none' }, flexDirection: 'row', alignItems: 'center' }}>
        <Box>
          <MobileSection />
        </Box>

        <Box
          sx={{
            height: 35,
            alignItems: "center",
            borderRadius: "27px",
            // //transition: "all .2s ease-in-out",
            border:
              `1px solid ${theme.palette.mode === "dark"
                ? theme.palette.dark.main
                : theme.palette.primary.light}`,

            justifyContent: 'center',
            display: 'flex',
            width: 40,
          }}

        >
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              //overflow: "hidden",
              borderRadius: "50%",
              // transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.main
                  : theme.palette.secondary.dark,
              "&:hover": {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.main
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.light
                    : theme.palette.secondary.light,
              },

            }}
            onClick={() => dispatch(openDrawer(!drawerOpen))}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="20px" />
          </Avatar>

        </Box>

      </Box>

      <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <ProfileContainer>
          <Avatar
            variant="rounded"
            sx={{
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: "hidden",
              borderRadius: "50%",
              transition: "all .2s ease-in-out",
              background:
                theme.palette.mode === "dark"
                  ? theme.palette.dark.main
                  : theme.palette.secondary.light,
              color:
                theme.palette.mode === "dark"
                  ? theme.palette.secondary.main
                  : theme.palette.secondary.dark,
              "&:hover": {
                background:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.main
                    : theme.palette.secondary.dark,
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.secondary.light
                    : theme.palette.secondary.light,
              },
            }}
            onClick={() => dispatch(openDrawer(!drawerOpen))}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="20px" />
          </Avatar>
        </ProfileContainer>
      </Box>

    </>
  );
};

export default Header;
